import { ref } from 'vue';
import type { PluginUsersPermissionsUser } from 'src/types/contentTypes';
export interface RegisterSignInFormData {
  identifier?: string;
  username?: string;
  email?: string;
  password?: string;
  repassword?: string;
  isRegister: boolean;
}

export interface StrapiUserMe {
  id: number;
  username: PluginUsersPermissionsUser['attributes']['username'];
  email: PluginUsersPermissionsUser['attributes']['email'];
  provider: PluginUsersPermissionsUser['attributes']['provider'];
  confirmed: PluginUsersPermissionsUser['attributes']['confirmed'];
  blocked: PluginUsersPermissionsUser['attributes']['blocked'];
  createdAt: PluginUsersPermissionsUser['attributes']['createdAt'];
  updatedAt: PluginUsersPermissionsUser['attributes']['updatedAt'];
}

export interface StrapiRegisterData {
  jwt: string;
  user: StrapiUserMe;
}

export function resetFormData() {
  formData.value = {
    isRegister: false,
    identifier: '',
    username: '',
    email: '',
    password: '',
    repassword: '',
  };
}

export const formData = ref<RegisterSignInFormData>({
  isRegister: false,
});
